<div mat-dialog-content>
  <p>{{mensaje}}</p>
  <div class="buttons">
    <button mat-button (click)="cancelar()">NO</button>
    <button mat-button (click)="confirmar()">SI</button>
  </div>
</div>
